(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["universal-monsters-mystery-eggs"] && !Shopify.designMode) return;
  try {
    
  function setupUmEggsCarousel(section) {
    var carousel = section.querySelector('[data-um-carousel]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-um-carousel-card]'));
    var prevButton = section.querySelector('[data-um-carousel-prev]');
    var nextButton = section.querySelector('[data-um-carousel-next]');
    var dotsContainer = section.querySelector('[data-um-carousel-dots]');
    var activeIndex = 0;
    var startX = 0;
    var dragging = false;
    var swiped = false;
    var supportsPointerEvents = Boolean(window.PointerEvent);

    function wrapped(index) {
      return (index + cards.length) % cards.length;
    }

    function setState() {
      if (!cards.length) return;

      var stateMap = {};
      stateMap[wrapped(activeIndex)] = 'active';
      stateMap[wrapped(activeIndex - 1)] = 'prev';
      stateMap[wrapped(activeIndex + 1)] = 'next';
      stateMap[wrapped(activeIndex - 2)] = 'far-prev';
      stateMap[wrapped(activeIndex + 2)] = 'far-next';

      cards.forEach(function(card, index) {
        var state = stateMap[index] || 'hidden';
        card.dataset.state = state;
        card.setAttribute('aria-hidden', state === 'hidden' ? 'true' : 'false');
      });

      if (dotsContainer) {
        dotsContainer.querySelectorAll('.um-eggs__carousel-dot').forEach(function(dot, index) {
          dot.classList.toggle('is-active', index === activeIndex);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
      }
    }

    function move(direction) {
      if (!cards.length) return;
      activeIndex = wrapped(activeIndex + direction);
      setState();
    }

    function finishSwipe(endX) {
      var delta = endX - startX;
      dragging = false;
      swiped = Math.abs(delta) > 42;
      if (carousel) carousel.classList.remove('is-dragging');

      if (swiped) {
        move(delta > 0 ? -1 : 1);
      }
    }

    if (dotsContainer && cards.length) {
      dotsContainer.innerHTML = cards.map(function(_, index) {
        return '<button class="um-eggs__carousel-dot" type="button" aria-label="Show monster ' + (index + 1) + '" data-um-carousel-dot="' + index + '"></button>';
      }).join('');

      dotsContainer.querySelectorAll('[data-um-carousel-dot]').forEach(function(dot) {
        dot.addEventListener('click', function() {
          activeIndex = Number(dot.dataset.umCarouselDot);
          setState();
        });
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function() { move(-1); });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function() { move(1); });
    }

    if (carousel) {
      if (supportsPointerEvents) {
        carousel.addEventListener('pointerdown', function(event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          dragging = true;
          swiped = false;
          startX = event.clientX;
          carousel.classList.add('is-dragging');
          if (carousel.setPointerCapture && typeof event.pointerId !== 'undefined') {
            carousel.setPointerCapture(event.pointerId);
          }
        });

        carousel.addEventListener('pointerup', function(event) {
          if (!dragging) return;
          finishSwipe(event.clientX);
          if (carousel.releasePointerCapture && typeof event.pointerId !== 'undefined') {
            carousel.releasePointerCapture(event.pointerId);
          }
        });

        carousel.addEventListener('pointerleave', function() {
          dragging = false;
          carousel.classList.remove('is-dragging');
        });

        carousel.addEventListener('pointercancel', function() {
          dragging = false;
          carousel.classList.remove('is-dragging');
        });
      }

      if (!supportsPointerEvents) {
        carousel.addEventListener('touchstart', function(event) {
          if (!event.touches.length) return;
          dragging = true;
          swiped = false;
          startX = event.touches[0].clientX;
          carousel.classList.add('is-dragging');
        }, { passive: true });

        carousel.addEventListener('touchend', function(event) {
          if (!dragging || !event.changedTouches.length) return;
          finishSwipe(event.changedTouches[0].clientX);
        }, { passive: true });
      }

      carousel.addEventListener('click', function(event) {
        if (!swiped) return;
        event.preventDefault();
        swiped = false;
      }, true);
    }

    setState();
  }

  function getUmCartRoute(path) {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + path;
    }

    return '/' + path;
  }

  function updateUmHeaderCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') {
      return;
    }

    var count = cart.item_count;
    var countText = String(count);
    var countElements = document.querySelectorAll('[data-cart-count], [data-header-cart-count], .cart-count, #CartCount, .js-cart-count, .cart-link__bubble-num, .cart-count-bubble span[aria-hidden="true"], .cart-count-bubble .visually-hidden + span');

    countElements.forEach(function(element) {
      element.textContent = countText;
      element.removeAttribute('hidden');
      element.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
    });

    var cartLinks = document.querySelectorAll('.site-nav__link--cart, a[href="/cart"].header__icon, a[href="/cart"], button[name="cart"], [data-cart-drawer-toggle], [data-cart-toggle]');

    cartLinks.forEach(function(link) {
      var bubble = link.querySelector('[data-cart-count], .cart-link__bubble-num, .um-eggs__cart-count');

      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'um-eggs__cart-count';
        bubble.setAttribute('data-cart-count', '');
        link.appendChild(bubble);
      }

      bubble.textContent = countText;
      bubble.hidden = count <= 0;
      bubble.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
      link.classList.toggle('cart-has-items', count > 0);
    });

    document.querySelectorAll('.cart-link__bubble, [data-cart-count-bubble], .cart-count-bubble, .um-eggs__cart-count').forEach(function(element) {
      element.classList.toggle('cart-link__bubble--visible', count > 0);
      element.classList.toggle('is-visible', count > 0);
      element.classList.toggle('hidden', count <= 0);
      element.hidden = count <= 0;
      if (count > 0) {
        element.removeAttribute('hidden');
      }
    });
  }

  function openThemeCartDrawer(cart, item, button) {
    updateUmHeaderCartCount(cart);

    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      bubbles: true,
      detail: {
        product: item,
        cart: cart,
        addToCartBtn: button
      }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { cart: cart } }));

    var drawer = document.querySelector('cart-drawer, [data-cart-drawer], .cart-drawer, #CartDrawer, .js-cart-drawer, .ajaxcart, #CartContainer');
    if (drawer) {
      if (typeof drawer.open === 'function') {
        drawer.open();
      }
      drawer.classList.add('is-open', 'active', 'animate');
      drawer.removeAttribute('hidden');
    }

    var toggle = document.querySelector('[data-cart-drawer-toggle], [data-cart-toggle], .site-nav__link--cart, a[href="/cart"].header__icon, button[name="cart"]');
    if (toggle && !drawer) {
      toggle.click();
    }
  }

  function setupUmEggsQuantity(section) {
    section.querySelectorAll('[data-um-quantity]').forEach(function(quantity) {
      if (quantity.dataset.umQuantityBound === 'true') {
        return;
      }

      quantity.dataset.umQuantityBound = 'true';

      quantity.addEventListener('click', function(event) {
        var minus = event.target.closest('[data-um-quantity-minus]');
        var plus = event.target.closest('[data-um-quantity-plus]');

        if (!minus && !plus) {
          return;
        }

        var input = quantity.querySelector('input[name="quantity"]');
        var current = parseInt(input.value, 10) || 1;

        if (minus) {
          input.value = Math.max(1, current - 1);
        }

        if (plus) {
          input.value = current + 1;
        }

        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function setupUmEggsAjaxCart(section) {
    section.querySelectorAll('[data-um-ajax-form]').forEach(function(form) {
      if (form.dataset.umAjaxBound === 'true') {
        return;
      }

      form.dataset.umAjaxBound = 'true';

      form.addEventListener('submit', function(event) {
        event.preventDefault();

        var button = form.querySelector('[data-um-atc]');
        var message = form.querySelector('[data-um-form-message]');
        var formData = new FormData(form);

        if (!formData.get('id')) {
          if (message) message.textContent = 'Choose a product first.';
          return;
        }

        if (button) {
          button.disabled = true;
          button.dataset.originalText = button.textContent;
          button.textContent = 'Adding...';
        }

        fetch(getUmCartRoute('cart/add.js'), {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function(response) {
            if (!response.ok) {
              return response.json().then(function(error) {
                throw error;
              });
            }
            return response.json();
          })
          .then(function(item) {
            return fetch(getUmCartRoute('cart.js'), {
              headers: { 'Accept': 'application/json' }
            }).then(function(response) {
              return response.json();
            }).then(function(cart) {
              return { item: item, cart: cart };
            });
          })
          .then(function(result) {
            if (message) message.textContent = 'Added to cart.';
            openThemeCartDrawer(result.cart, result.item, button);
          })
          .catch(function(error) {
            var description = error && (error.description || error.message);
            if (message) message.textContent = description || 'Unable to add to cart.';
            document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
              bubbles: true,
              detail: {
                errorMessage: description || 'Unable to add to cart.',
                addToCartBtn: button
              }
            }));
          })
          .finally(function() {
            if (button) {
              button.disabled = false;
              button.textContent = button.dataset.originalText || 'Add to cart';
            }
          });
      });
    });
  }

  function setupUmEggsVideoPoster(section) {
    section.querySelectorAll('[data-um-video-poster]').forEach(function(poster) {
      poster.addEventListener('click', function() {
        var frame = poster.closest('.um-eggs__video-frame');
        var video = frame ? frame.querySelector('video') : null;

        poster.classList.add('is-hidden');

        if (video && typeof video.play === 'function') {
          video.play().catch(function() {
            poster.classList.remove('is-hidden');
          });
        }
      });
    });
  }

  function setupUmEggsSection(section) {
    setupUmEggsCarousel(section);
    setupUmEggsQuantity(section);
    setupUmEggsAjaxCart(section);
    setupUmEggsVideoPoster(section);
  }

  function setupAllUmEggsSections() {
    document.querySelectorAll('[data-um-eggs-section]').forEach(setupUmEggsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAllUmEggsSections);
  } else {
    setupAllUmEggsSections();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('[data-um-eggs-section]');
    if (section) {
      setupUmEggsSection(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
